<template>
  <v-app id="app" cols="12" sm="6" md="3" lg="3" xl="3">
    <v-app-bar class="primary" app>
      <router-link to="/" tag="span" style="cursor: pointer">
        <img src="@/assets/large.png" class="logoPng" align="center" justify="center" height="90px">
      </router-link>
      <v-toolbar-title class="justify-center headline text-uppercase">
        <span class="font-weight-bold"></span>
      </v-toolbar-title>
    </v-app-bar>
  <v-main>
      <router-view></router-view>
  </v-main>
   <Footer></Footer>
  </v-app>
</template>

<script>
import Footer from './components/Footer.vue';

export default {
  name: 'App',
  components: {
    Footer,
  },
};
</script>
